<template>
    <div class="contact-page">
        <h2 class="text-muted kursiv">
            <TerminalSimulator 
                referrer="contact.head" 
                text="Der erste Schritt zählt" 
                :isWritten="pageLoadingStore.isLoaded('contact.head')" 
                @textIsWritten="() => pageLoadingStore.setLoaded('contact.head', true)"
            />
        </h2>
        <br>
        <br>
        <form ref="formRef"  @submit="onSubmit">
            <div class="mb-3">
                <input @blur="checkInputValidity" @focus="setInputValid" type="text" class="form-control" id="fname" name="fname" placeholder="* Vorname" v-model="fname" required>
            </div>
            <div class="mb-3">
                <input @blur="checkInputValidity" @focus="setInputValid" type="text" class="form-control" id="lname" name="lname" placeholder="* Nachname" v-model="lname" required>
            </div>
            <div class="mb-3">
                <input type="text" class="form-control" id="subject" name="subject" placeholder="Betreff" v-model="subject">
            </div>
            <div class="mb-3">
                <input @blur="checkInputValidity" @focus="setInputValid" type="email" class="form-control" id="email" name="email" placeholder="* E-mail" v-model="email" required>
            </div>
            <div class="mb-3">
                <input type="text" class="form-control" id="org" name="org" placeholder="Firma, Organisation" v-model="org">
            </div>
            <div class="mb-3">
                <textarea @blur="checkInputValidity" @focus="setInputValid" class="form-control" id="msg" name="msg" placeholder="* Ihre Nachricht" v-model="msg" rows="6" required></textarea>
            </div>

            <div id="dsasec-container">
                <div id="dsasec-func-box">
                    <div id="toggler-wrapper">
                        <div class="toggler" id="toggler-left">
                            <input type="text" id="dsasec-field" name="dsasec-name" autocomplete="off" value="&#10799;">
                        </div>
                        <div class="toggler" id="toggler-right"></div>
                    </div>
                    <span id="dsasec-msg-box">* Ich bin keine Maschine!</span>
                </div>
                <span id="dsasec-js-off">Bitte JavaScript aktivieren!</span>
            </div>

            <div class="btn-wrapper">
                <button type="submit" class="btn btn-primary">
                    <TerminalSimulator
                        writeSpeed=500
                        text="Absenden" 
                        :isLast="true"
                        :isWritten="pageLoadingStore.isLoaded('contact.submit')" 
                        referrer="contact.submit" 
                        @textIsWritten="() => pageLoadingStore.setLoaded('contact.submit', true)"
                    />
                </button>
            </div>
        </form>
    </div>
    <div ref="toast" class="toast align-items-center text-bg-primary border-0" role="error" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
            <div class="toast-body">
            <!--Die Nachricht wird dynamisch geändert-->
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
    </div>
</template>

<script>
// import { onMounted, ref, nextTick } from 'vue';
import TerminalSimulator from '@/components/TerminalSimulator.vue';
import { usePageLoadingStore } from '../stores/pageLoadingStore.js';
import { Toast } from 'bootstrap/dist/js/bootstrap.bundle.js';

export default {
    name: 'ContactPage',
    data () {
        return{
            /** @type {HTMLElement|null} */
            toastEl:null,
            /** @type {Toast|null} */
            toast:null,
            fname:null,
            lname:null,
            subject:null,
            email:null,
            org:null,
            msg:null,
            formRef: null,
            isCheckSuccessed: false,
            dsaSecContainer: null,
            dsaSec: null,
            msgBox: null,
            jsIsOff: null,
            togglerWrapper: null,
            togglerRightSide: null,
            togglerLeftSide: null,
            speedCam: {
                startTimestamp: 0,
                endTimestamp: 0,
                getSpeed: function() {
                    return this.endTimestamp - this.startTimestamp;
                }
            },
            posX:null,
            posX2:null,
            isMoveEnded: false,
            pageLoadingStore: usePageLoadingStore()
        }
    },
    mounted() {
        this.formRef = this.$refs.form;
        this.dsaSecContainer = document.getElementById("dsasec-container");
        this.dsaSec = document.getElementById("dsasec-field");
        this.msgBox = document.getElementById("dsasec-msg-box");
        this.jsIsOff = document.getElementById("dsasec-js-off");
        this.togglerWrapper = document.getElementById("toggler-wrapper");
        this.togglerRightSide = document.getElementById("toggler-right");
        this.togglerLeftSide = document.getElementById("toggler-left");

        this.jsIsOff.style.display = "none";


        // Jetzt wird der Event-Handler initial zugewiesen:
        if (window.ontouchstart !== undefined) {
            this.dsaSec.ontouchstart = this.onMousedownOrTouchstart;
        } else {
            this.dsaSec.onmousedown = this.onMousedownOrTouchstart;
        }


        this.dsaSecContainer.addEventListener("mouseenter", this.showInstruction);
        this.dsaSec.addEventListener("focus", this.showInstruction);
        this.dsaSecContainer.addEventListener("mouseleave", () => {
            if (!this.isCheckSuccessed) {
                this.msgBox.innerHTML = "* Ich bin keine Maschine!";
                this.msgBox.classList.remove("dsasec-animate-msg-box");
            }
        });

        //Toast
        this.toastEl = this.$refs.toast;
        this.toast = new Toast(this.toastEl);

    },
    methods: {
        
        anchorSwitch () {
            this.togglerWrapper.onmousemove = null;
            this.dsaSec.style.position = "static";
            this.dsaSec.style.cursor = "grab";
        },

        setToFail (element) {
            this.togglerLeftSide.appendChild(this.dsaSec);
            this.msgBox.innerHTML = "* Ich bin keine Maschine!";
            this.isCheckSuccessed = false;
            element.value = String.fromCharCode(10799);
            element.style.color = "pink";
            element.disabled = false;
            this.dsaSecContainer.style.backgroundColor = "pink";
            this.togglerRightSide.style.backgroundColor = "pink";
            this.togglerLeftSide.style.backgroundColor = "pink";
        },

        setToSuccess (element) {
            this.isCheckSuccessed = true;
            this.msgBox.innerHTML = "Ich bin keine Maschine!";
            this.msgBox.classList.remove("dsasec-animate-msg-box");    
            element.value = "";
            element.placeholder = String.fromCharCode(10003);
            element.disabled = true;
            this.togglerRightSide.style.backgroundColor = "lightgreen";
            this.togglerLeftSide.style.backgroundColor = "lightgreen";
            this.dsaSecContainer.style.backgroundColor = "lightgreen";
            this.dsaSecContainer.classList.add('success-msg');
        },
        endMove() {
            this.anchorSwitch();
            this.speedCam.endTimestamp = Date.now();

            const isDsaSecRight = this.dsaSec.parentElement.id === "toggler-right";
            if (isDsaSecRight && this.speedCam.getSpeed() > 120) {
                this.setToSuccess(this.dsaSec);
            } else {
                this.setToFail(this.dsaSec);
            }
        },
        moveField (e) {
            if (e.touches) {
            let touch = e.touches[0];
            this.posX = touch.clientX - Math.floor(this.togglerWrapper.getBoundingClientRect().left);
            } else {
            this.posX = e.clientX - Math.floor(this.togglerWrapper.getBoundingClientRect().left);
            this.posX2 = e.clientX - Math.floor(this.togglerWrapper.getBoundingClientRect().left);
            }

            if (this.posX < 20) this.posX = 20;
            if (this.posX > 60) this.posX = 60;

            this.dsaSec.style.position = "absolute";
            this.dsaSec.style.left = (this.posX - this.dsaSec.offsetWidth / 2) + "px";  

            if (this.posX > 50) {
            this.dsaSec.style.position = "static";
            this.togglerRightSide.appendChild(this.dsaSec);
            } else {
            this.togglerLeftSide.appendChild(this.dsaSec);
            }

            if (!this.isMoveEnded) {
            if (this.posX2 < 15 || this.posX2 > 75) {
                this.endMove();
                this.isMoveEnded = true;
            }
            }
        },
        onMousedownOrTouchstart() {
            this.dsaSec.style.cursor = "grabbing";
            this.speedCam.startTimestamp = Date.now();

            // Je nach Gerätetyp den richtigen Event zuweisen.
            if (window.ontouchstart!== undefined) {
                // this.dsaSec.ontouchstart = this.onMousedownOrTouchstart;
                this.togglerWrapper.ontouchmove = this.moveField;
                this.togglerWrapper.ontouchend = this.endMove;
            } else {
                // this.dsaSec.onmousedown = this.onMousedownOrTouchstart;
                this.togglerWrapper.onmousemove = this.moveField;
                this.togglerWrapper.onmouseup = this.endMove;
            }
        },
        showInstruction() {
            if (!this.isCheckSuccessed) {
                this.msgBox.innerHTML = "<span id='msg-arrow'>&raquo;</span> Ziehe mich nach rechts!";
                this.msgBox.classList.add("dsasec-animate-msg-box");              
            }
        },
        onSubmit(event) {
            event.preventDefault();
            if(!this.isCheckSuccessed){// wenn die spam-falle nicht betätigt wurde.
                this.setToFail(this.dsaSec);// Ansicht der spam-falle zu fehlgeschlagen ändern.
            }else{
                // Send E-Mail
                const formData = new FormData();
                formData.append('fname', this.fname || '');
                formData.append('lname', this.lname || '');
                formData.append('subject', this.subject || '');
                formData.append('email', this.email || '');
                formData.append('org', this.org || '');
                formData.append('msg', this.msg || '');
                formData.append('dsasec',this.dsaSec.value);

                fetch(
                    '/mailer/src/send.php',
                    {
                        method: 'POST',
                        body: formData
                    }
                ).then(res=>{
                    res.text().then(answer => {
                        if(answer === 'OK'){
                            // Show success Message
                            this.toastEl.style.setProperty('background-color', '#31ad22', 'important');
                            this.toastEl.querySelector('.toast-body').innerHTML = '<strong>Vielen Dank!</strong><br>Ihre Nachricht wurde erfolgreich gesendet.';
                            this.toast.show()
                            // Clear Fields if E-Mail has been sent.
                            this.fname = null;
                            this.lname = null;
                            this.subject = null;
                            this.email = null;
                            this.org = null;
                            this.msg = null;
                        }else{
                            this.toastEl.style.setProperty('background-color', '#ee2f51', 'important');
                            this.toastEl.querySelector('.toast-body').innerHTML = '<strong>Ihre Nachricht konnte leider nicht gesendet werden.</strong><br>Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.';
                            this.toast.show()
                        }
                    })
                })

            }
        },
        checkInputValidity(event){
            const input = event.target;
            if(input?.value.length < 1){
                input.style.backgroundColor = 'pink';
            }
        },
        setInputValid(event){
            const input = event.target;
            if(input){
                input.style.backgroundColor = null;
            }
        }
    },
    // watch: {
    //     isCheckSuccessed(val) {
    //     if (val) {
    //         this.msgBox.innerHTML = "Ich bin keine Maschine!";
    //         this.msgBox.classList.remove("dsasec-animate-msg-box");    
    //     } else {
    //         this.msgBox.innerHTML = "* Ich bin keine Maschine!";
    //     }
    //     },
    //     fname(newVal, oldVal) {
    //     console.log(`fname geändert: ${oldVal} → ${newVal}`);
    //     },
    //     lname(newVal, oldVal) {
    //     console.log(`lname geändert: ${oldVal} → ${newVal}`);
    //     },
    //     subject(newVal, oldVal) {
    //     console.log(`subject geändert: ${oldVal} → ${newVal}`);
    //     },
    //     email(newVal, oldVal) {
    //     console.log(`email geändert: ${oldVal} → ${newVal}`);
    //     },
    //     org(newVal, oldVal) {
    //     console.log(`org geändert: ${oldVal} → ${newVal}`);
    //     },
    //     msg(newVal, oldVal) {
    //     console.log(`msg geändert: ${oldVal} → ${newVal}`);
    //     }
    // },

    components: {
        TerminalSimulator
    }
};

</script>


<style scoped>
.contact-page{
    font-family: orbitron;
    color: white !important;
    .text-muted{
        color: white !important;
        font-size: x-large;
        font-weight: bolder;
        text-align: center;
    }
    form{
        display: flex;
        flex-direction: column;;
        justify-content: center;
        align-items: center;
        margin: 0px 50px;
        input{
            border-radius: var(--bs-border-radius);
        }
        div{
            width: 800px;
            max-width: 100%;
        }
        .btn-wrapper{
            display: flex;
            justify-content: flex-end;
        }
    }
}

/* visiblepot */
#dsasec-container {
	margin-top: 30px;
	margin-bottom: 30px;
	max-width: 300px;
	min-width: 220px;
	padding: 15px 15px 0 15px;
	border-radius: 5px;
	border: 1px solid lightgray;
	display: grid;
	grid-template-columns: 32% 68%;
	grid-template-rows: 35px 35px;
	justify-items: baseline;
	align-items: center;
	transition: background-color 2s;
	background-color: #fff4;
}
.success-msg #toggler-wrapper .toggler{
	background-color: #31ad22 !important;
}

#dsasec-container:hover {
	border: 1px solid gray;
}

#dsasec-func-box{
	display: flex;
	align-items: center;
	gap: 15px;
}

#toggler-wrapper {
	position: relative;
	/* grid-area: 1 / span 2 / span 1; */
	width: 80px;
	display: grid;
	grid-template-areas: "left right";
	align-items: center;
}
#toggler-wrapper .toggler {
	display: flex;
	justify-content: center;
	justify-items: center;
	align-items: center;
	width: 40px;
	height: 35px;
	padding: 2px;
	background-color: #be0c1d;
}
#toggler-wrapper .toggler #dsasec-field {
	/* z-index: 100 !important; */
	position: absolute;
	width: 37px !important;
	height: 25px !important;
	cursor: grab;
	border-radius: 15px !important;
	background-color: white !important;
	text-align: center !important;
	font-family: initial !important;
	font-size: 20px;
	box-shadow: 0 0 3px gray !important;
	outline: none !important;
	border: none !important;
	caret-color: #fffffa !important;
	color: #be0c1d;
}

#toggler-wrapper #toggler-left {
	grid-area: left;
	border-top: 2px;
	border-left: 2px;
	border-bottom: 2px;
	border-right: 0;
	border-color: gray;
	border-style: solid;
	border-top-left-radius: 15px;
	border-bottom-left-radius: 15px;
}
#toggler-wrapper #toggler-right {
	border-top-right-radius: 15px;
	border-bottom-right-radius: 15px;
	grid-area: right;
	border-top: 2px;
	border-right: 2px;
	border-bottom: 2px;
	border-left: 0;
	border-color: gray;
	border-style: solid;
}
#dsasec-msg-box {
	/* grid-area: 0.5 / span 2 / span 1; */
	font-size: 15px !important;
	white-space: nowrap !important;
}
.dsasec-animate-msg-box {
	left: 0;
	font-size: medium;
	animation: toggleme 1.2s linear infinite;
}

#dsasec-js-off {
	grid-area: 2 / span 1/ span 2;
	font-size: 1rem;
	align-self: end;
	color: #be0c1d;
	white-space: nowrap;
	animation: zoom 1.2s linear infinite;
}
 
#v-pot-err{
	background-color: pink;
	color: #be0c1d;
	padding: 15px;
	border-radius: 5px;
	margin-left: 20px;
	white-space: nowrap;
	position: relative;
	top: -25px;
	font-weight: bold;
}


/* Animations */
@keyframes toggleme {
	0% {
		transform: translateX(0);
	}
	30% {
		transform: translateX(15px);
	}
	70% {
		transform: translateX(0);
	}
}

@keyframes zoom {
	0% {
		transform:scale(1)
	}
	30% {
		transform: scale(1.2);
	}
	70% {
		transform: scale(1);
	}
}

#dsasec-container{
    max-width: 350px;
    #dsasec-func-box{
        display: flex;
        justify-content: space-between;
        gap: 15px;
    }
}

.toast{
    position: fixed;
    left: 10px;
    bottom: 50px;
}
</style>